import { render, staticRenderFns } from "./formerstudents.vue?vue&type=template&id=56a573b6&scoped=true"
import script from "./formerstudents.vue?vue&type=script&lang=js"
export * from "./formerstudents.vue?vue&type=script&lang=js"
import style0 from "./formerstudents.vue?vue&type=style&index=0&id=56a573b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a573b6",
  null
  
)

export default component.exports